import { EActionTypes } from '../../actions/myHomeMigrationBanner';
import { TReduxActions } from '../../types/redux';
import { IMyHomeMigrationBannerState } from '../../types/redux/myHomeMigrationBanner';

export const initialState: IMyHomeMigrationBannerState = {
  myHomeIdMigration: null,
};

export const myHomeMigrationBannerReducer = (state = initialState, action: TReduxActions) => {
  if (action.type === EActionTypes.SetMyHomeIdMigration) {
    return {
      ...state,
      myHomeIdMigration: action.payload,
    };
  }

  return state;
};
